<div
  class="file-item"
  (click)="previewFile(file(), $event)"
  [dataSelector]="dataSelector"
  [ngClass]="{ 'file-item-masked': file()?.isMasked }"
  tooltip="This file is restricted and cannot be viewed or modified."
  [tooltipEnabled]="file()?.isMasked"
>
  <div
    class="d-inline-flex align-items-center file-item-info"
    [class.file-item-info--flagged]="isFileFlaggingEnabled() && file().isFlagged"
       [dataSelector]="dataSelector + (isFileFlaggingEnabled() && file().isFlagged ? '-file-info-flagged' : '-file-info') ">

    <!-- Conditional icon -->
    <div class="left-icon">
      @if (isFileFlaggingEnabled() && file().isFlagged) {
        <awn-file-item-icon iconName="flag-pennant"
                            iconNamespace="phosphor"
                            [class.is-flagged]="isFileFlaggingEnabled() && file().isFlagged"
                            [cssClasses]="['is-flagged','icon-color-red-200', 'icon-fill-red-200']"
                            [dataSelector]="dataSelector + '-file-icon'">
        </awn-file-item-icon>
      } @else {
        <awn-file-item-icon [fileExtension]="file().extension" [dataSelector]="dataSelector + '-file-icon'"/>
      }
    </div>

    <!-- Conditional content layout -->
    @if (isFileFlaggingEnabled()) {
      <!-- Normal file content -->
      <div class="file-item-details">
        <div class="file-item-content">
          <div class="file-item-name" [dataSelector]="dataSelector + '-file-name'">
            {{ file().name }}.{{ file().extension }}

            @if (file().version && file().version > 1) {
              <span class="file-version">V{{ file().version }}</span>
            }

            <div class="file-item-meta">
              @if(fileMetaText()) {
                <span class="file-meta-text uploaded-by">
                  {{ fileMetaText() }}
                </span>
              }

              @if (isFileFlaggingEnabled() && file().isFlagged && file().flaggedAt) {
                <span class="file-meta-text flagged">Flagged on {{ file().flaggedAt | date:'MMM d, y h:mm a' }}</span>
              }
            </div>
          </div>

          <!-- Suggested pill should not show in case file is flagged -->
          @if(file().wasAutoCategorized && !(isFileFlaggingEnabled() && file().isFlagged)) {
            <div class="suggested-pill" [dataSelector]="dataSelector + '-file-suggested-pill'">
              <aiwyn-icon name="sparkle" namespace="phosphor" fill="#55559E" class="me-1" [height]="16" [width]="16"></aiwyn-icon>
              Suggested
            </div>
          }
        </div>
      </div>
    } @else {
      <!-- Normal file content -->
      <div class="file-item-content">
        <span class="file-item-name" [dataSelector]="dataSelector + '-file-name'">{{ file().name }}.{{ file().extension }}</span>

        <div *ngIf="file().wasAutoCategorized" class="suggested-pill" [dataSelector]="dataSelector + '-file-suggested-pill'">
          <aiwyn-icon name="sparkle" namespace="phosphor" fill="#55559E" class="me-1" [height]="16" [width]="16"></aiwyn-icon>
          Suggested
        </div>
      </div>
    }
  </div>

  <div class="d-inline-flex align-items-center file-item-actions" [dataSelector]="dataSelector + (isFileFlaggingEnabled() && file().isFlagged ? '-file-actions-flagged' : '-file-actions') ">
    <!-- Download button - shared by both layouts -->
    <div class="action-button-wrapper">
      <button
        andButton
        color="ghost"
        size="small"
        [class]="{
          'me-1': isEditingAllowed(),
          'cursor-not-allowed': file()?.isMasked
        }"
        [isLoading]="isLoading()"
        [disabled]="file()?.isMasked"
        (click)="downloadFile(file(), $event)"
        [dataSelector]="dataSelector + '-file-download-button-' "
      >
        <aiwyn-icon name="download" [height]="16" [width]="16"></aiwyn-icon>
      </button>
    </div>

    @if(isEditingAllowed()) {
      @if (isFileFlaggingEnabled() && file().isFlagged) {
        <!-- Upload New Version button for flagged files -->
        <button
          andButton
          color="ghost"
          size="small"
          [isLoading]="replacementFileLoading() || false"
          (click)="replaceFile(file(), $event)"
          [dataSelector]="dataSelector + '-file-replace-button'"
        >
          Upload New Version
        </button>
      } @else {
        <!-- Menu for normal files -->
        <div class="action-button-wrapper">
          <button
            andButton
            color="ghost"
            size="small"
            [matMenuTriggerFor]="menu"
            [showMenuIcon]="false"
            [disabled]="file()?.isMasked"
            [ngClass]="{ 'cursor-not-allowed': file()?.isMasked }"
            (click)="$event.stopPropagation()"
            [dataSelector]="dataSelector + '-file-menu-button'"
          >
            <aiwyn-icon name="more-vertical" [height]="16" [width]="16"></aiwyn-icon>
          </button>
        </div>

        <mat-menu
          #menu="matMenu"
          xPosition="before"
        >
          <div class="d-flex align-items-center" mat-menu-item (click)="linkToRequests(file())" [dataSelector]="dataSelector + '-file-link-option'">
            <p class="me-1">Link to requests</p>
            <aiwyn-icon name="copy" [height]="16" [width]="16"></aiwyn-icon>
          </div>

          <div class="d-flex align-items-center" mat-menu-item (click)="previewFile(file())" [dataSelector]="dataSelector + '-file-preview-option'">
            <p class="me-1">Preview File</p>
            <aiwyn-icon name="search" [height]="16" [width]="16"></aiwyn-icon>
          </div>

          @if(documentItem()) {
            <div
              mat-menu-item
              class="d-flex align-items-center"
              (click)="unlinkFile(file())"
              [dataSelector]="dataSelector + '-file-unlink-option'"
            >
              <p class="me-1">Unlink File</p>
              <aiwyn-icon name="x" [height]="16" [width]="16"></aiwyn-icon>
            </div>
          }
        </mat-menu>
      }
    }
  </div>
</div>

@if(isEditingAllowed()) {
  <!-- Hidden upload component for file replacement -->
  <awn-upload-files
    type="hidden"
    [multiple]="false"
    [accept]="acceptedFileTypes"
    [entityId]="jobId$ | async"
    [triggerFileSelection$]="_triggerFileSelection$"
    (onFileUploadStart)="onReplaceFileUploadStart($event)"
    (onFileUploadEnd)="onReplaceFileUploadComplete($event)"
    [dataSelector]="dataSelector + '-replace-uploader'"
  ></awn-upload-files>
}
